<template>
  <div :style="{ direction: dir }">
    <AppHeader />
    <main class="main_block">
      <div class="container">
        <div class="main">
          <router-view />
        </div>
      </div>
    </main>
    <AppFooter />
  </div>
</template>

<script setup>
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import { computed } from 'vue';
import { useStore } from 'vuex';
// import MainSideBar from '@/components/MainSideBar';
// import { computed } from "vue";
// import store from "@/store";
defineOptions({
  name:'DefaultLayout'
})
// const isMainSideBarHidden = computed(() => store.getters.isMainSideBarHidden);

const store = useStore();
const locale = computed(() => store.getters.locale);
const dir = computed(() => locale.value === "he" ? 'rtl' : 'ltr');
</script>

<style>

</style>